import {mapFields} from "vuex-map-fields";

export default {
    data() {
        return {
            ttFired: false,
        };
    },

    computed: {
        ...mapFields([
            'round2.complaint.id',
            'round2.complaint.affiliate_tracked',
            'round2.complaint.least_one_poa_signed',
            'round2.complaint.travel_plan_ok',
        ]),
        tradeTrackerConfig() {
            const host = window.location.host;

            if (host.includes("flyforsinkelse.dk")) {
                return {
                    campaignID: "40437",
                    productID: "64111",
                    domain: "deals.flyforsinkelse.dk",
                };
            }

            if (host.includes("flygforsening.se")) {
                return {
                    campaignID: "40278",
                    productID: "63933",
                    domain: "deals.flygforsening.se",
                };
            }

            if (host.includes("peruutetutlennot.fi")) {
                return {
                    campaignID: "40279",
                    productID: "63934",
                    domain: "deals.peruutetutlennot.fi",
                };
            }

            if (host.includes("zwrotzalot.pl")) {
                return {
                    campaignID: "40281",
                    productID: "63936",
                    domain: "deals.zwrotzalot.pl",
                };
            }

            if (host.includes("zpozdeno.cz")) {
                return {
                    campaignID: "40283",
                    productID: "63938",
                    domain: "deals.zpozdeno.cz",
                };
            }

            if (host.includes("flyforsinkelser.no")) {
                return {
                    campaignID: "40284",
                    productID: "63939",
                    domain: "deals.flyforsinkelser.no",
                };
            }

            if (host.includes("flugrueckerstattung.de")) {
                return {
                    campaignID: "40280",
                    productID: "63935",
                    domain: "deals.flugrueckerstattung.de",
                };
            }

            return null;
        },

        hasTradeTrackerAttribution() {
            return document.cookie.includes("affiliate_source=trade_tracker");
        },

        shouldFireTradeTracker() {
            if (!this.hasTradeTrackerAttribution) return false;
            if (!this.tradeTrackerConfig) return false;
            if (!this.id) return false;
            if (this.affiliate_tracked) return false;
            if (!this.least_one_poa_signed) return false;
            if (!this.travel_plan_ok) return false;
            if (this.ttFired) return false;

            return true;
        },
        transactionId() {
            return this.id;
        }
    },

    methods: {
        fireTradeTrackerConversionIfNeed() {
            if (!this.shouldFireTradeTracker) return;
            if (typeof window === "undefined") return;

            const cfg = this.tradeTrackerConfig;
            window.ttConversionOptions = window.ttConversionOptions || [];

            window.ttConversionOptions.push({
                type: "lead",
                campaignID: cfg.campaignID,
                trackingGroupID: "",
                productID: cfg.productID,
                transactionID: String(this.id),
                transactionAmount: "0",
                currency: "EUR",
                quantity: "1",
                descrMerchant: "",
                descrAffiliate: "",
                vc: "",
            });

            // load hosted conversion script
            const script = document.createElement("script");
            script.async = true;
            script.src = `https://${cfg.domain}/conversion?s=${encodeURIComponent(cfg.campaignID)}&t=m`;

            document.head.appendChild(script);

            this.ttFired = true;
            this.markTTComplaintAffiliateTracked()

            console.log("[TradeTracker] lead fired", this.id);
        },

        markTTComplaintAffiliateTracked() {
            this.$store.commit('round2/UPDATE_COMPLAINT_FIELD', { path: 'affiliate_tracked', value: true })

            let formData = new FormData()
            formData.append(`complaint[affiliate_tracked]`, 'true')
            this.$store.dispatch("round2/putComplaint", formData)
        }
    },
};